import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { LabelI18nService } from './label-i18n.service';
import { ProjectType } from '../_models/projectType';

@Injectable({
  providedIn: 'root'
})
export class ProjectTypeService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private labelI18n: LabelI18nService
  ) {}

  getAll() {
    return this.http.get<ProjectType[]>(`${environment.apiUrl}/ProjectTypes`, { headers: this.authService.headers }).pipe(map((projectTypes) => this.labelI18n.localizeProjectTypes(projectTypes)));
  }
}
